<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <Caption :label="label"></Caption>
        </div>

        <ul>
          <li v-for="m of list">
            <ReferenceItem
              :id="m.id"
              :image="m.image"
              :text1="m.name"
              :text2="m.sub_text"
              :text3="m.desc"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
import ReferenceItem from "./ReferenceItem.vue";
import client from "../client/client";

export default {
  props: ["label"],
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
    ReferenceItem,
  },
  mounted() {
    let url = "/api/portfolio/list"
    if(this.$props.label != '포트폴리오')
      url += "?category=" + this.$props.label

    client
      .get(url)
      .then((res) => {
        this.list = res.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #f5f8fa;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

ul {
  margin-top: 40px;
  width: 100%;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding:0;
}
li:not(:last-child) {
  margin-right: 25px;
  margin-bottom: 25px;
}

ul li {
  display: inline-block;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #f5f8fa;
  }

  .content {
    width: 100vw;
    padding-left: 0px;
    text-align: center;
  }

  ul {
    text-align: center; 
    display: flex; 
    justify-content: center;
    width: fit-content;
    height: fit-content;
    list-style-type: none;
    overflow: hidden;
    overflow-y: scroll;
    padding-inline-start: 0px;
  }

  li:not(:last-child) {
    margin-right: 0px;
    margin-bottom: 15px;
  }

  ul li {
    display: block;
  }
}
</style>
  